import { styled } from '@mui/material/styles';
import PhoneInputComponent from 'react-phone-number-input';

export const StyledPhoneInput = styled(PhoneInputComponent)({
  '& .PhoneInputInput': {
    fontFamily: 'Roboto !important',
  },
});
